import {useConfig} from '../config';

export const useSelfviewMirrorMode = () => {
    const [isUserFacing] = useConfig('isUserFacing');

    const [mirrorSelfview] = useConfig('mirrorSelfview');

    return isUserFacing ? mirrorSelfview : false;
};
